import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Dialog } from "@activecollab/components";
import PropTypes from "prop-types";
import { useHotJarContext } from "~/components/Providers/HotJar/context";
import { BasicDetailsOnboarding } from "~/pages/Onboarding/BasicDetailsOnboarding";
import { OrgDetailsOnboarding } from "~/pages/Onboarding/OrgDetailsOnboarding";
import { getIsHotJarEnabled, getIsTrial } from "~/store/selectors/selector.configOptions";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch.jsx";

export const OnboardingDialog = ({ step, setStep }) => {
  const isHotJarEnabled = useSelector(getIsHotJarEnabled);
  const isTrial = useSelector(getIsTrial);
  const { isHotJarStarted, setIsHotJarStarted } = useHotJarContext();

  useEffect(() => {
    if (isHotJarEnabled && !isHotJarStarted && isTrial) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML =
        "(function(h,o,t,j,a,r){" +
        "h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};" +
        "h._hjSettings={hjid:438975,hjsv:6};" +
        "a=o.getElementsByTagName('head')[0];" +
        "r=o.createElement('script');r.async=1;" +
        "r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;" +
        "a.appendChild(r);" +
        "})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";

      document.head.appendChild(script);

      if (typeof setIsHotJarStarted === "function") {
        setIsHotJarStarted(true);
      }
    }
  }, [isHotJarEnabled, isHotJarStarted, isTrial, setIsHotJarStarted]);
  useEffect(() => {
    fetch({ url: `${Angie.api_url}/setup-wizard/onboarding-started`, method: "POST" });
  }, []);
  return (
    <Dialog
      disableCloseOnEsc
      open
      className="tw-w-[360px] sm:tw-w-[540px]"
    >
      {step === 1 ? <BasicDetailsOnboarding afterSubmit={setStep} /> : null}
      {step === 2 ? <OrgDetailsOnboarding /> : null}
    </Dialog>
  );
};

OnboardingDialog.propTypes = {
  step: PropTypes.number,
  setStep: PropTypes.func,
};
